import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey'; // @ts-expect-error TODO type

import { getCollectionI18nKey } from '../../../utils/i18n';

const ResultsHeaderDescription = ({
  collection
}) => {
  if (!collection) {
    return null;
  }

  const descriptionKey = getCollectionI18nKey(collection, 'descriptionText');

  if (!isValidI18nKey(descriptionKey)) {
    return null;
  }

  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: descriptionKey
  });
};

export default ResultsHeaderDescription;